<template>
  <div class="tool-section">
    <h3 class="section-heading">{{ title }}</h3>
    <div class="cards-grid" :class="{ 'two-columns': columns === 2 }">
      <ToolCard
        v-for="tool in tools"
        :key="tool.id"
        :title="tool.title"
        :description="tool.description"
        :iconColor="tool.iconColor"
        :link="tool.link"
        :coming-soon="tool.comingSoon"
      />
    </div>
  </div>
</template>

<script>
import ToolCard from './ToolCard.vue'

export default {
  name: 'ToolSection',
  components: {
    ToolCard
  },
  props: {
    title: {
      type: String,
      required: true
    },
    tools: {
      type: Array,
      required: true
    },
    columns: {
      type: Number,
      default: 3
    }
  }
}
</script>

<style scoped>
.tool-section {
  margin-bottom: 60px;
}

.section-heading {
  font-size: 28px;
  font-weight: bold;
  color: #1a1a2e;
  margin-bottom: 30px;
  padding-left: 15px;
  border-left: 4px solid #667eea;
}

.cards-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.cards-grid.two-columns {
  grid-template-columns: repeat(2, 1fr);
  max-width: 800px;
}

@media (max-width: 968px) {
  .cards-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  
  .cards-grid.two-columns {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .tool-section {
    margin-bottom: 40px;
  }
  
  .section-heading {
    font-size: 22px;
    margin-bottom: 20px;
  }
  
  .cards-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }
}
</style>
